// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/widget-definition.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / actions / custom-tabs).

import type { DetailPageConfig } from "../../components/composition/DetailPage";
import { widgetDefinitionsApi } from "../../api/widget-definitions";
import type { WidgetDefinition } from "../../api/types";
// override-block:imports BEGIN
// CHG-2471 / ITER-905213 — Widget Studio S5 (read-only catalog detail).
import { createElement } from "react";
import type { ReactNode } from "react";
import { chipCell, toneBadge, type Tone } from "../../lib/widget-cells";
// override-block:imports END

// override-block:helpers BEGIN
// Definition-status tones (widget-definition-status value-space).
const DEF_STATUS_TONE: Record<string, Tone> = {
  active:     { bg: "var(--color-success-tint)", fg: "var(--color-success)" },
  inactive:   { bg: "var(--color-bg-subtle)",    fg: "var(--color-text-secondary)" },
  deprecated: { bg: "var(--color-warning-tint)", fg: "var(--color-warning)" },
};

function definitionOverview(r: WidgetDefinition): ReactNode {
  const rows: Array<[string, string]> = [
    ["Widget key", r.widget_key ?? "—"],
    ["Family", (r.family ?? "—").toString().replace(/_/g, " ")],
    ["Module", r.module ?? "—"],
    ["Type", r.type ?? "—"],
    ["Default surface", r.default_surface ?? "—"],
    ["Sensitivity", (r.sensitivity_level ?? "—").toString().replace(/_/g, " ")],
    ["Version", r.version ?? "—"],
    ["Auto-registration", r.allow_auto_registration ? "Allowed" : "Not allowed"],
    ["Default policy", (r.default_registration_policy ?? "—").toString().replace(/_/g, " ")],
  ];
  return createElement(
    "div",
    { className: "card", style: { padding: 16, fontSize: 13, lineHeight: 1.8 } },
    ...rows.map(([k, v]) =>
      createElement(
        "div",
        { key: k, style: { display: "flex", justifyContent: "space-between", gap: 16 } },
        createElement("span", { style: { color: "var(--color-text-muted)" } }, k),
        createElement("span", { style: { textTransform: "capitalize" } }, v),
      ),
    ),
  );
}
// override-block:helpers END

export const widgetDefinitionDetailConfig: DetailPageConfig<WidgetDefinition> = {
  idParam: "widgetDefinitionId",
  queryKey: (id: string) => ["widget-definitions", "detail", id] as const,
  queryFn: (id: string) => widgetDefinitionsApi.getWidgetDefinition(id),
  backTo: "/channels/widgets/catalog",
  // override-block:title BEGIN
  title: (r) => r.display_name,
  // override-block:title END
  // override-block:subtitle BEGIN
  subtitle: (r) => r.widget_key ?? null,
  // override-block:subtitle END
  statusCards: (r, _fmt) => [
    // override-block:statcard-family BEGIN
    {
      id: "family",
      label: "Family",
      value: null,
      format: "text",
      tone: "g-events",
      render: chipCell(r.family),
    },
    // override-block:statcard-family END
    {
      id: "type",
      label: "Type",
      value: r.type,
      format: "text",
      tone: "g-home",
    },
    {
      id: "sensitivity",
      label: "Sensitivity",
      value: r.sensitivity_level,
      format: "text",
      tone: "g-people",
    },
    // override-block:statcard-status BEGIN
    {
      id: "status",
      label: "Status",
      value: null,
      format: "text",
      tone: "g-mygiving",
      render: toneBadge(r.status, DEF_STATUS_TONE),
    },
    // override-block:statcard-status END
  ],
  actions: (_r) => [
    // override-block:actions BEGIN
    // override-block:actions END
  ],
  tabs: [
    // override-block:tab-overview BEGIN
    {
      id: "overview",
      label: "Overview",
      render: (r) => definitionOverview(r),
    },
    // override-block:tab-overview END
    // override-block:custom-tabs BEGIN
    // override-block:custom-tabs END
  ],
};
